import styled from 'styled-components';

export const Container = styled.strong`
  font-weight: bold !important;
`;
